export const EU_ROUTES = {
  euRoot: "/employee/eu",
  facilities: "/employee/eu/facilities",
  facilitiesBulkAdd: "/employee/eu/facilities/bulk-add",
  boundaries: "/employee/eu/boundaries",
  boundaryUpload: "/employee/eu/boundary/upload",
} as const;
